module.exports = __webpack_public_path__ + "static/media/USA.fb23f31b.png";